// extracted by mini-css-extract-plugin
export default {"wrapper":"RenderServicePills_wrapper__VMK4x","serviceItem":"RenderServicePills_serviceItem__-LW28"};